module.exports = __webpack_public_path__ + "img/s1.bb03ff2e.jpg";